<script setup>
import TeachersListGradeLevel from './TeachersListGradeLevel.vue';

const GRADES = [1, 2, 3, 4, 5, 6];
</script>

<template>
  <TeachersListGradeLevel :grades="GRADES" />
</template>
